module.exports = __webpack_public_path__ + "static/media/wheel-bg.e0ce5ba2.png";